import React from "react";
import {Title} from "@src/components/ui/Title";
import styles from "./index.module.scss";

import advantageIcon4 from "@imgs/home/advantage_icon4.png";
import advantageIcon5 from "@imgs/home/advantage_icon5.png";
import advantageIcon6 from "@imgs/home/advantage_icon6.png";
import {Button} from "tea-component";
import {Link, useNavigate, useParams} from "react-router-dom";

//constext导入
import { MyContext } from "@src/layouts/basic-layout";
//导入react-redux
import { useSelector } from "react-redux";

export const Advantage = () => {
  const navigate = useNavigate();

  const loginObject = React.useContext(MyContext);
  const isLogin = useSelector((state: any) => state.user.userInfo.token);

  //点击按钮跳转到对应的页面的方法
  const handleClick = (path: string) => {
    //如果是block页面，则直接跳转到block页面
    if (path === '/explorer/block') {
      navigate(path);
    }else {
      //判断是否登录
      if (isLogin) {
        navigate(path);
      }else{
        //登录弹窗
        loginObject.setLoginVisible(true);
        //登录后要跳转的页面
        loginObject.setLoginPath(path);
      }
    }
  };

  return <div className={styles.advantage}>
    <Title text={"技术优势"} />
    <div className={styles.desc}>采用新一代区块链ChainMaker开源底层服务，打造高性能、高可信、高安全的基础设施</div>
    <div className={styles.contentBox}>
      <div className={`${styles.item} ${styles.item1}`}>
        <div className={styles.text}>数据不出本地的前提下全流程证据保全，区块链技术确保证据不可篡改</div>
      </div>
      <div className={`${styles.item} ${styles.item2}`}>
        <div className={styles.text}>基于证据链的管理功能，自动关联证据，一键批量提取/下载证据包</div>
      </div>
      <div className={`${styles.item} ${styles.item3}`}>
        <div className={styles.text}>证据Hash同步公证处、司法鉴定中心，支持司法链在线核验证据</div>
      </div>
    </div>
    <div className={styles.contentBox1}>
      <div className={styles.item}>
        <div className={styles.img}>
          <img src={advantageIcon4}/>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <div>区块</div>
            <div className={styles.line}/>
          </div>
          <div className={styles.text}>通过区块链去中心化、分布式账本等特点为原创电子数据生成数据指纹并存储在区块链上，明确电子数据的归属</div>
          <div className={styles.btn}>
            <Button className={styles.btn_content} type="primary" onClick={() => handleClick('/explorer/block')}>{'立即体验'}</Button>
          </div>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.content}>
          <div className={styles.title}>
            <div>便捷取证服务</div>
            <div className={styles.line}/>
          </div>
          <div className={styles.text}>通过对网页、APP、用户操作行为等进行在线取证，将取证过程、存证数据记录在区块链上，形成完备的证据链，为当事人提供有效的证据支持</div>
          <div className={styles.btn}>
            <Button className={styles.btn_content} type="primary" onClick={() => handleClick('/explorer/forensics')}>{'立即体验'}</Button>
          </div>
        </div>
        <div className={styles.img} style={{textAlign: "right"}}>
          <img src={advantageIcon5}/>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.img}>

          <img src={advantageIcon6}/>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <div>验真</div>
            <div className={styles.line}/>
          </div>
          <div className={styles.text}>证据一键打包，通过发送证据提取码在线提取证据、下载证据，提供安全、省心、高效的证据流转服务</div>
          <div className={styles.btn}>
            <Button className={styles.btn_content} type="primary" onClick={() => handleClick('/explorer/fileValidation')}>{'立即体验'}</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
